/**
 * TOPIC-POSITION.UTILS
 * Position of the topics as the editor numbers them : "#2.3" (third topic of the second axis), "#x.2" (second topic without axis)
 */

//axisIds : the axes in the order of the editor. A topic of an axis that is not in the list only gets its rank in the axis ("#?.3")
export function getTopicPositions(topics: { id: string; AxisId?: string | null }[], axisIds: string[]): Record<string, string> {
  const counters: Record<string, number> = {}
  const positions: Record<string, string> = {}
  topics.forEach((topic) => {
    const key = topic.AxisId || ""
    counters[key] = (counters[key] || 0) + 1
    const axisNumber = !key ? "x" : axisIds.indexOf(key) >= 0 ? String(axisIds.indexOf(key) + 1) : "?"
    positions[topic.id] = "#" + axisNumber + "." + counters[key]
  })
  return positions
}
